<app-navigation-header title="Alert Report" i18n-title="@@alertReport-title">
	<app-data-set
		#dataSet
		[dataSource]="dataSource"
		defaultPresentationMode="table"
		[appBreadcrumbLabel]="breadcrumbLabel"
		[rowId]="rowId"
		firstColumnProperty="deviceSerialNumber"
	>
		<app-data-set-toolbar>
			<div class="flex-space-around">
				<div *appActionGroup style="width: 100%; display: flex; flex-direction: column">
					<app-data-set-action-button
						svgIcon="sl-filter"
						label="Refine Filters"
						i18n-label="@@alertReport-refineFilter"
						(click)="onRefineFiltersClicked()"
						data-automation-id="alert-report-refine-filters-button"
					></app-data-set-action-button>
				</div>
				<div *appActionGroup style="width: 100%; display: flex; flex-direction: column">
					<app-data-set-action-button
						svgIcon="sl-download"
						label="Download"
						i18n-label="@@alertReport-download"
						(click)="onDownloadClicked()"
						data-automation-id="alert-report-download-button"
					></app-data-set-action-button>
				</div>
			</div>
		</app-data-set-toolbar>

		<app-data-set-content>
			<app-data-set-table-view>
				@if (
					loadingService.isLoading(generateAlertReportLoadingKey) ||
					loadingService.isLoading(generateAlertReportCsvLoadingKey) ||
					!finishedLoadingInitData
				) {
					<app-data-set-loading-row />
				}
				<table
					mat-table
					[dataSource]="dataSource"
					matSortActive="dateTime"
					matSortDirection="desc"
					matSort
					[hidden]="
						loadingService.isLoading(generateAlertReportLoadingKey) ||
						loadingService.isLoading(generateAlertReportCsvLoadingKey) ||
						!finishedLoadingInitData
					"
				>
					<tr class="mat-row" *matNoDataRow>
						<td class="mat-cell" [colSpan]="displayedColumns.length" i18n="@@dataSetTable-noRecordsFound">
							No records found.
						</td>
					</tr>
					<ng-container matColumnDef="deviceSerialNumber">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@alertReport-deviceSerialNumber">
							Device Serial Number
						</th>
						<td mat-cell *matCellDef="let row">{{ row.deviceSerialNumber }}</td>
					</ng-container>

					<ng-container matColumnDef="deviceOwner">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@alertReport-deviceOwner">Device Owner</th>
						<td mat-cell *matCellDef="let row">{{ row.deviceOwner }}</td>
					</ng-container>

					<ng-container matColumnDef="deviceAlertType">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@alertReport-deviceAlertType">Alert Type</th>
						<td mat-cell *matCellDef="let row">{{ row.deviceAlertType | alertReportFormat }}</td>
					</ng-container>

					@if (isCareCompany) {
						<ng-container matColumnDef="clientName">
							<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@inventoryReport-client">Client</th>
							<td mat-cell *matCellDef="let row">{{ row?.clientFirstName ?? '' }} {{ row?.clientLastName ?? '' }}</td>
						</ng-container>

						<ng-container matColumnDef="clientIdn">
							<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@inventoryReport-clientIdn">Client IDN</th>
							<td mat-cell *matCellDef="let row">{{ row?.clientIdn ?? '' }}</td>
						</ng-container>
					}

					<ng-container matColumnDef="propertyName">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@alertReport-propertyName">Property Name</th>
						<td mat-cell *matCellDef="let row">{{ row.propertyName }}</td>
					</ng-container>

					<ng-container matColumnDef="deviceLocation">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@alertReport-deviceLocation">
							Device Location
						</th>
						<td mat-cell *matCellDef="let row">{{ row.deviceLocation }}</td>
					</ng-container>

					<ng-container matColumnDef="dateTime">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@alertReport-dateTime">Trigger Time</th>
						<td mat-cell *matCellDef="let row">
							<div
								[innerHTML]="
									row.dateTime
										? (row.dateTime
												| date: 'mediumDate' : timeZoneService.utcOffset(row.dateTime, row.locationTimezoneName)) +
											'<br/>' +
											(row.dateTime
												| date: 'shortTime' : timeZoneService.utcOffset(row.dateTime, row.locationTimezoneName)) +
											' ' +
											(row.locationTimezoneName | abbreviatedTimezone: row.dateTime)
										: '- - -'
								"
							></div>
						</td>
					</ng-container>

					<ng-container matColumnDef="postalCode">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@alertReport-postalCode">Postal Code</th>
						<td mat-cell *matCellDef="let row">{{ row.postalCode }}</td>
					</ng-container>

					<ng-container matColumnDef="userName">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@alertReport-userName">User</th>
						<td mat-cell *matCellDef="let row">{{ row.userName }}</td>
					</ng-container>

					<ng-container matColumnDef="userCompany">
						<th mat-header-cell *matHeaderCellDef mat-sort-header i18n="@@alertReport-userCompany">User's Company</th>
						<td mat-cell *matCellDef="let row">{{ row.userCompany }}</td>
					</ng-container>

					<tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
					<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
				</table>
			</app-data-set-table-view>
		</app-data-set-content>
	</app-data-set>
</app-navigation-header>
